
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import MyProspectsList from "@/components/myprospects/MyProspectsList.vue";

export default defineComponent({
  name: "myprospects",
  components: {
    MyProspectsList,
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      setCurrentPageTitle("OVI KYB");
      tabIndex.value = parseInt(localStorage.getItem("myProspectsTab") || "0");
    });
  },
});
